import api from "../utils/api";

const BASE = "/api/sophos-firewalls";

const compactParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(([, value]) => {
      return (
        value !== undefined &&
        value !== null &&
        value !== ""
      );
    }),
  );

const normalisePayload = (payload = {}) => {
  const result = {
    ...payload,
  };

  if (
    Object.prototype.hasOwnProperty.call(
      result,
      "is_active",
    )
  ) {
    result.is_active = Boolean(
      result.is_active,
    );
  }

  if (
    Object.prototype.hasOwnProperty.call(
      result,
      "is_primary",
    )
  ) {
    result.is_primary = Boolean(
      result.is_primary,
    );
  }

  return result;
};

/**
 * GET /api/sophos-firewalls
 */
export const getSophosFirewalls = async (
  params = {},
) =>
  (
    await api.get(BASE, {
      params: compactParams(params),
    })
  ).data;

/**
 * GET /api/sophos-firewalls/{id}
 */
export const getSophosFirewall = async (
  id,
) =>
  (
    await api.get(
      `${BASE}/${id}`,
    )
  ).data;

/**
 * POST /api/sophos-firewalls
 */
export const createSophosFirewall = async (
  payload,
) =>
  (
    await api.post(
      BASE,
      normalisePayload(payload),
    )
  ).data;

/**
 * PUT / PATCH /api/sophos-firewalls/{id}
 */
export const updateSophosFirewall = async (
  id,
  payload,
) =>
  (
    await api.patch(
      `${BASE}/${id}`,
      normalisePayload(payload),
    )
  ).data;

/**
 * DELETE /api/sophos-firewalls/{id}
 */
export const deleteSophosFirewall = async (
  id,
) =>
  (
    await api.delete(
      `${BASE}/${id}`,
    )
  ).data;

/**
 * POST /api/sophos-firewalls/{id}/restore
 */
export const restoreSophosFirewall = async (
  id,
) =>
  (
    await api.post(
      `${BASE}/${id}/restore`,
    )
  ).data;

/**
 * DELETE /api/sophos-firewalls/{id}/force
 */
export const forceDeleteSophosFirewall = async (
  id,
) =>
  (
    await api.delete(
      `${BASE}/${id}/force`,
    )
  ).data;

/**
 * POST /api/sophos-firewalls/{firewallId}/shops
 *
 * Payload:
 * {
 *   shop_id,
 *   is_primary,
 *   connection_role,
 *   notes
 * }
 */
export const assignFirewallShop = async (
  firewallId,
  payload,
) =>
  (
    await api.post(
      `${BASE}/${firewallId}/shops`,
      normalisePayload(payload),
    )
  ).data;

/**
 * POST /api/sophos-firewalls/{firewallId}/shops/bulk
 *
 * Payload:
 * {
 *   shop_ids: [],
 *   is_primary,
 *   connection_role
 * }
 */
export const assignFirewallShops = async (
  firewallId,
  payload,
) =>
  (
    await api.post(
      `${BASE}/${firewallId}/shops/bulk`,
      normalisePayload(payload),
    )
  ).data;

/**
 * PATCH /api/sophos-firewalls/{firewallId}/shops/{shopId}
 */
export const updateFirewallShopAssignment =
  async (
    firewallId,
    shopId,
    payload,
  ) =>
    (
      await api.patch(
        `${BASE}/${firewallId}/shops/${shopId}`,
        normalisePayload(payload),
      )
    ).data;

/**
 * DELETE /api/sophos-firewalls/{firewallId}/shops/{shopId}/unassign
 */
export const unassignFirewallShop = async (
  firewallId,
  shopId,
) =>
  (
    await api.delete(
      `${BASE}/${firewallId}/shops/${shopId}/unassign`,
    )
  ).data;

/**
 * DELETE /api/sophos-firewalls/{firewallId}/shops/{shopId}
 */
export const removeFirewallShop = async (
  firewallId,
  shopId,
) =>
  (
    await api.delete(
      `${BASE}/${firewallId}/shops/${shopId}`,
    )
  ).data;